export default [
  {
    path: '',
    name: 'order-detail',
    component: () => import('pages/orders/_id/index.vue')
  },
  {
    path: 'cancel',
    name: 'orders-id-cancel',
    component: () => import('pages/orders/_id/cancel.vue')
  },
  {
    path: 'change-order',
    component: () => import('pages/orders/_id/change-order.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-change-order',
        component: () => import('pages/orders/_id/change-order/index.vue'),
      },
      {
        path: 'bom-items',
        component: () => import('pages/bom-items.vue'),
        children: [
          {
            name: 'orders-id-change-order-bom-items',
            path: '',
            component: () => import('pages/bom-items/index.vue'),
            meta: { hideBackButton: true },
          },
          {
            name: 'orders-id-change-order-bom-items-uuid',
            path: ':uuid',
            component: () => import('pages/bom-items/_uuid.vue'),
          },
        ]
      },
    ],
  },
  {
    path: 'edit',
    name: 'orders-id-edit',
    component: () => import('pages/orders/_id/edit.vue')
  },
  {
    path: 'final-adjustments',
    component: () => import('pages/orders/_id/final-adjustments.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-final-adjustments',
        component: () => import('pages/orders/_id/final-adjustments/index.vue'),
      },
      {
        path: 'bom-items',
        component: () => import('pages/bom-items.vue'),
        children: [
          {
            name: 'orders-id-final-adjustments-bom-items',
            path: '',
            component: () => import('pages/bom-items/index.vue'),
            meta: { hideBackButton: true },
          },
          {
            name: 'orders-id-final-adjustments-bom-items-uuid',
            path: ':uuid',
            component: () => import('pages/bom-items/_uuid.vue'),
          },
        ],
      }
    ],
  },
  {
    path: 'in-store',
    component: () => import('pages/orders/_id/in-store.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-in-store',
        component: () => import('pages/orders/_id/in-store/index.vue'),
      },
      {
        path: 'split',
        name: 'orders-id-in-store-split',
        meta: { hideBackButton: true, backOnClose: true },
        component: () => import('pages/orders/_id/in-store/split.vue'),
      },
    ],
  },
  {
    path: 'invite-suppliers',
    component: () => import('pages/orders/_id/invite-suppliers.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-invite-suppliers',
        component: () => import('pages/orders/_id/invite-suppliers/index.vue'),
      },
      {
        path: 'select',
        name: 'orders-id-invite-suppliers-select',
        component: () => import('pages/orders/_id/invite-suppliers/select.vue'),
      },
      {
        path: 'review',
        name: 'orders-id-invite-suppliers-review',
        component: () => import('pages/orders/_id/invite-suppliers/review.vue'),
      }
    ],
  },
  {
    path: 'quote/:quoteId',
    name: 'review-quote',
    component: () => import('pages/orders/_id/quote/_quoteId.vue')
  },
  {
    path: 'receive',
    component: () => import('pages/orders/_id/receive.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-receive',
        component: () => import('pages/orders/_id/receive/index.vue'),
      },
      {
        path: 'orders/:id/receive/submit',
        name: 'orders-id-receive-submit',
        component: () => import('pages/orders/_id/receive/submit.vue')
      },
    ]
  },
  {
    path: 'receive/partial',
    name: 'orders-id-receive-partial',
    meta: { hideHeader: true },
    component: () => import('pages/orders/_id/receive/partial.vue')
  },
  {
    path: 'release',
    component: () => import('pages/orders/_id/release.vue'),
    children: [
      {
        path: '',
        name: 'orders-id-release',
        component: () => import('pages/orders/_id/release/index.vue'),
      },
      {
        path: 'delivery',
        name: 'orders-id-release-delivery',
        component: () => import('pages/orders/_id/release/delivery.vue')
      },
    ]
  }
]
